<template>
    <div class="pa-1 mb-3">
        <div class="text-body">Dans le cadre de notre démarche écoresponsable, nous souhaitons évaluer les émissions de
            carbone occasionnées par les déplacements de nos participants. Pour nous aider, il vous suffit de renseigner
            quelques informations dans la section suivante. N’hésitez pas à être précis et à prendre en compte votre
            trajet aller et retour. Tous les dons seront reversés au Conservatoire d'Espaces
            Naturels d'Auvergne.</div>
        <div v-if="form.empreinte > 0"><b>Mon empreinte : {{ form.empreinte }} kg de CO2</b></div>
        <v-btn class="mt-2" variant="flat" color="dark-green" @click="open_popup = true"><v-icon class="mr-2"
                size="x-large" icon="mdi-leaf"></v-icon> Calculer
            mon empreinte
            carbone </v-btn>

        <v-dialog v-model="open_popup">
            <v-card prepend-icon="mdi-leaf" title="Calcul de votre empreinte carbone">
                <v-card-text>
                    <v-expansion-panels class="mb-4">
                        <v-expansion-panel>
                            <v-expansion-panel-title expand-icon="mdi-menu-down">
                                <div class="text-h6">En savoir plus</div>
                            </v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <p>Dans le cadre de notre démarche écoresponsable, nous souhaitons évaluer les émissions
                                    de
                                    carbone occasionnées par les déplacements de nos participants. Pour nous aider, il
                                    vous
                                    suffit de renseigner quelques informations dans la section suivante. N’hésitez pas à
                                    être précis et à prendre en compte votre trajet aller et retour.</p>

                                <p>Ces données nous permettront d’évaluer votre empreinte carbone individuelle sur la
                                    VVX
                                    (en kg de CO2) et ainsi celle de l’intégralité de l’évènement afin de la réduire au
                                    maximum.</p>

                                <p>Si vous le souhaitez, il vous est possible d’estimer vos émissions de gaz à effet de
                                    serre puis de compenser vos émissions en soutenant le programme Sylvae porté par le
                                    Conservatoire d’espaces naturels d’Auvergne pour acquérir et préserver des parcelles
                                    de
                                    vieilles forêts en Auvergne. Le programme Sylvae a permis d’identifier 111 zones
                                    prioritaires de vieilles forêts sur lesquelles le CEN conduit un travail progressif
                                    d’animation foncière afin de réaliser à l’amiable l’acquisition des parcelles
                                    concernées.</p>

                                <p>Depuis 2019 la VVX est mécène du programme Sylvae du CEN Auvergne dans le cadre de sa
                                    politique écoresponsable.</p>

                                <p>En savoir plus sur le programme Sylvae réseau de vieilles forêts en Auvergne
                                    <br><a class="text-primary-dark"
                                        href="https://cen-auvergne.fr/les-projets/sylvae-reseau-de-vieilles-forets-en-auvergne"
                                        target="_blank">
                                        https://cen-auvergne.fr/les-projets/sylvae-reseau-de-vieilles-forets-en-auvergne</a>
                                </p>

                                <p>Suivre l’avancée de ce programme
                                    <br><a class="text-primary-dark"
                                        href="https://cen-auvergne.fr/les-projets/sylvae-reseau-de-vieilles-forets-en-auvergne/sylvae-l-avancement-du-projet"
                                        target="_blank">https://cen-auvergne.fr/les-projets/sylvae-reseau-de-vieilles-forets-en-auvergne/sylvae-l-avancement-du-projet</a>
                                </p>

                                <p>Les garanties apportées par le CEN Auvergne quant à ses actions
                                    <br><a class="text-primary-dark"
                                        href="https://cen-auvergne.fr/agir-avec-nous/compenser-volontairement-ses-emissions-de-carbone/les-garanties-du-cen-auvergne"
                                        target="_blank">https://cen-auvergne.fr/agir-avec-nous/compenser-volontairement-ses-emissions-de-carbone/les-garanties-du-cen-auvergne</a>
                                </p>
                                <p>Tous les dons seront reversés au Conservatoire d'Espaces Naturels d'Auvergne.</p>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                    <label class="field_label">Nombre de moyens de transport différents</label>
                    <v-select v-model="form.nombre_transport" :items="nb_transports_items"></v-select>
                    <div v-if="form.nombre_transport >= 1">
                        <div class="text-h6 my-2"><u>Premier moyen de transport</u></div>
                        <label class="field_label">Je voyage en</label>
                        <v-select v-model="form.transport_1.type" :items="type_transport"></v-select>
                        <div
                            v-if="form.transport_1.type == 'Voiture' || form.transport_1.type == 'Covoiturage trailers'">
                            <label class="field_label">Nombre de personnes à bord</label>
                            <v-text-field v-model="form.transport_1.nb_personnes" type="number"></v-text-field>
                            <label class="field_label">Type de motorisation</label>
                            <v-select v-model="form.transport_1.type_motorisation"
                                :items="type_motorisation_items"></v-select>
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_1.distance" type="number"></v-text-field>
                        </div>
                        <div v-else-if="form.transport_1.type == 'Train'">
                            <label class="field_label">Type de train</label>
                            <v-select v-model="form.transport_1.type_train" :items="type_train_items"></v-select>
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_1.distance" type="number"></v-text-field>
                        </div>
                        <div v-else-if="form.transport_1.type == 'Avion'">
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_1.distance" type="number"></v-text-field>
                        </div>
                    </div>
                    <div v-if="form.nombre_transport >= 2">
                        <div class="text-h6 my-2"><u>Second moyen de transport</u></div>
                        <label class="field_label">Je voyage en</label>
                        <v-select v-model="form.transport_2.type" :items="type_transport"></v-select>
                        <div
                            v-if="form.transport_2.type == 'Voiture' || form.transport_2.type == 'Covoiturage trailers'">
                            <label class="field_label">Nombre de personnes à bord</label>
                            <v-text-field v-model="form.transport_2.nb_personnes" type="number"></v-text-field>
                            <label class="field_label">Type de motorisation</label>
                            <v-select v-model="form.transport_2.type_motorisation"
                                :items="type_motorisation_items"></v-select>
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_2.distance" type="number"></v-text-field>
                        </div>
                        <div v-else-if="form.transport_2.type == 'Train'">
                            <label class="field_label">Type de train</label>
                            <v-select v-model="form.transport_2.type_train" :items="type_train_items"></v-select>
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_2.distance" type="number"></v-text-field>
                        </div>
                        <div v-else-if="form.transport_2.type == 'Avion'">
                            <label class="field_label">Indiquez votre distance en km</label>
                            <v-text-field v-model="form.transport_2.distance" type="number"></v-text-field>
                        </div>
                    </div>
                    <div class="d-flex justify-center">
                        <v-btn class="mt-2" variant="flat" @click="form.calculate()" prepend-icon="mdi-molecule-co2"
                            color="dark-green">Calculer mon empreinte
                            carbone</v-btn>
                    </div>

                    <div v-if="form.empreinte > 0">
                        <v-divider></v-divider>
                        <div class="text-h6 mt-4">Votre empreinte carbone est de {{ form.empreinte }} kg de CO2</div>
                        <div class="text-body">Vous pouvez compenser vos émissions en soutenant le programme Sylvae
                            porté
                            par le Conservatoire d’espaces naturels d’Auvergne pour acquérir et préserver des parcelles
                            de
                            vieilles forêts en Auvergne. Tous les dons seront reversés au Conservatoire d'Espaces
                            Naturels d'Auvergne.</div>
                        <v-btn class="mt-2" variant="flat" color="dark-green" @click="make_donation">Je fais un don de
                            {{ form.prix }}€</v-btn>
                    </div>
                </v-card-text>
                <template v-slot:actions>
                    <v-btn class="ms-auto" @click="open_popup = false" color="primary-dark">Fermer</v-btn>
                </template>
            </v-card>
        </v-dialog>


        <!-- Your component's HTML template goes here -->
    </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from '@/stores/bookingStore';

export default {
    name: 'FormulaireEmpreinteCarbone',
    data() {
        return {
            open_popup: false,
            form: {},
            nb_transports_items: [1, 2],
            type_transport: ['Voiture', 'Covoiturage trailers', 'Train', 'Avion'],
            type_train_items: ["TGV", "Intercités", "TER"],
            type_motorisation_items: ["Essence", "Gazole", "Hybride", "Electrique", "Bio Carburant", "GPL"]
            // Your component's data goes here
        };
    },
    computed: {
        ...mapStores(useMainStore, useBookingStore),
        // Your component's computed properties go here
    },
    methods: {
        make_donation() {
            let first_inscription_in_booking = this.bookingStore.inscriptions[0];
            // si l'inscription n'est pas initilisée ou si elle n'a pas de donation on ne fait rien
            if (!first_inscription_in_booking || !first_inscription_in_booking.donation) {
                return;
            }

            first_inscription_in_booking.donation.set_active(this.form.prix);
            first_inscription_in_booking.update_cart("donation");
            first_inscription_in_booking.compute_cart();
            this.bookingStore.compute_cart();
            this.open_popup = false;

        }
        // Your component's methods go here
    },
    mounted() {
        this.bookingStore.init_formulaire_empreinte_carbone();
        this.form = this.bookingStore.formulaire_empreinte_carbone;

        // Code to run when the component is mounted goes here
    },
};
</script>

<style scoped>
/* Your component's CSS styles go here */
</style>